import * as React from "react";
import { AlertCircle } from "lucide-react";
import { Alert, AlertDescription } from "@/components/ui/alert";

interface UploadModalErrorsProps {
  errorMessage: string;
}

export const UploadModalErrors: React.FC<UploadModalErrorsProps> = ({ errorMessage }) => (
  <Alert variant="destructive" className="mt-4">
    <AlertCircle className="h-4 w-4" />
    <div className="max-h-[220px] overflow-y-auto">
      <AlertDescription>{errorMessage}</AlertDescription>
    </div>
  </Alert>
);
